// Remembers the active Train set across reloads/navigation. Single-set (the
// Train tab picks one set at a time); plain string id in localStorage, mirroring
// the token-store persistence style (SSR-safe + quota/private-mode tolerant).
const STORAGE_KEY = "train.selectedSetId";

export function loadSelectedSetId(): string | null {
  if (typeof localStorage === "undefined") return null;
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function saveSelectedSetId(setId: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, setId);
  } catch {
    /* private mode / quota — ignore, in-memory state still applies */
  }
}

export function clearSelectedSetId(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
